import React from 'react';
import { NavItem } from './NavItem';

interface NavItemData {
  icon: React.ElementType;
  label: string;
  to: string;
  isActive?: boolean;
  isPermanentActive?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  badge?: string;
}

interface NavGroupWithTitleProps {
  title?: string;
  items: NavItemData[];
  className?: string;
}

export const NavGroupWithTitle: React.FC<NavGroupWithTitleProps> = ({
  title,
  items,
  className
}) => {
  return (
    // O espaçamento entre grupos vem do gap-[18px] do container da sidebar, não de marginTop
    <div className={className} style={{ marginTop: title ? '0px' : '0px' }}>
      {title && (
        <div style={{ margin: '0 14px 8px 14px' }}>
          <span
            className="text-[10px] font-semibold uppercase tracking-[0.06em]"
            style={{ color: '#98A2B3' }}
          >
            {title}
          </span>
        </div>
      )}

      <div className="flex flex-col gap-[4px]">
        {items.map((item) => (
          <NavItem
            key={item.to + item.label}
            icon={item.icon}
            label={item.label}
            to={item.to}
            isActive={item.isActive}
            isPermanentActive={item.isPermanentActive}
            onClick={item.onClick}
            badge={item.badge}
          />
        ))}
      </div>
    </div>
  );
};
